import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)

const getRunPath = (taskType) => {
  if (taskType === 'run_immediately') {
    return 'run_once';
  } else if (taskType === 'run_continuously') {
    return 'run_continuously';
  }

  return 'run_scheduled';
}

export const runTask = ({
  orchestrationId,
  workspaceId,
  taskName,
  taskType = 'run_immediately',
  schedule = undefined,
  timeout = undefined,
  jsonStr = ''
}) => {
  const runPath = getRunPath(taskType);

  const json = jsonStr?.length ? JSON.parse(jsonStr) : {};

  const body = {
    name: taskName,
    orch_id: orchestrationId,
    workspace_id: workspaceId,
    json,
  }

  if (runPath === 'run_scheduled') {
    body.schedule = schedule;
  }
  if (timeout !== undefined && timeout !== null) {
    body.timeout = timeout;
  }
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  };

  return postToApi(`v1/api/task/${runPath}`, fetchOptions)
}

export default runTask;
